// Shared defaults between helper and utility
const DEFAULTS = {
  listType: 'ordered',
  dismiss: false,
  border: null,
  insert: 'before',
  size: 'large',
  remind: false,
  neverShow: false,
  language: 'en',
  defaultStrings: {
    en: {
      closeText: 'close',
      closeMessageADAText: 'Message',
      warning: 'warning icon',
      error: 'error icon',
      info: 'info icon',
      help: 'help icon',
      success: 'success icon'
    },
    es: {
      closeText: 'cerrar',
      closeMessageADAText: 'Mensaje',
      warning: 'icono de advertencia',
      error: 'icono de error',
      info: 'icono de informaci&oacute;n',
      success: 'icono de &eacute;xito'
    }
  }
};

/**
 * Messaging Handlebar Helper
 */
class MessagingDefaultsUtility {
  /**
   * Gets default configuration properties for Messaging
   * @returns {object} Default Messaging properties object
   */
  static getDefaultConfig() {
    return DEFAULTS;
  }
}

export { MessagingDefaultsUtility as default };
